import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
import './RequireAuth.css';

const FullPageSplash: React.FC = () => (
  <div className="auth-full-page-splash" aria-busy="true" />
);

const AuthErrorState: React.FC = () => {
  const { error, retry } = useAuth();
  return (
    <div className="auth-error-state">
      <p className="auth-error-state-text">{error ?? 'Something went wrong.'}</p>
      <button className="auth-error-state-retry" onClick={retry}>Retry</button>
    </div>
  );
};

// There's no /login page to redirect to anymore — sign-in is a popup. Open
// it automatically on arrival, and leave a manual trigger in case the user
// dismissed it; this component re-renders as <Outlet /> the moment status
// flips to 'authenticated', so a successful sign-in resumes right here.
const SignInRequired: React.FC = () => {
  const { openLoginModal } = useAuth();

  useEffect(() => {
    openLoginModal();
  }, [openLoginModal]);

  return (
    <div className="auth-sign-in-required">
      <p className="auth-sign-in-required-text">Sign in to view this page.</p>
      <button className="auth-sign-in-required-button" onClick={openLoginModal}>Sign in</button>
    </div>
  );
};

export default function RequireAuth() {
  const { status } = useAuth();

  if (status === 'loading') return <FullPageSplash />;
  if (status === 'error') return <AuthErrorState />;
  if (status === 'unauthenticated') return <SignInRequired />;
  return <Outlet />;
}
